export const osu_valid_email_extensions = [
    'osu.edu',
    'buckeyemail.osu.edu',
    'u.osu.edu',
    'mail.osu.edu',
    'fisher.osu.edu',
    'moritzlaw.osu.edu',
    'engineering.osu.edu',
    'chemistry.osu.edu',
    'ece.osu.edu',
    'mae.osu.edu',
    'bme.osu.edu',
    'physics.osu.edu',
    'math.osu.edu',
    'biology.osu.edu',
    'cfaes.osu.edu',
    'ati.osu.edu',
    'lima.osu.edu',
    'mansfield.osu.edu',
    'marion.osu.edu',
    'newark.osu.edu',
    'wooster.osu.edu',
    'pharmacy.osu.edu',
    'nursing.osu.edu',
    'dentistry.osu.edu',
    've t.osu.edu',
    'vet.osu.edu',
    'cph.osu.edu',
    'fisher.osu.edu',
    'library.osu.edu',
    'admission.osu.edu',
    'hr.osu.edu',
    'studentlife.osu.edu',
    'athletics.osu.edu',
    'artsandsciences.osu.edu',
    'askabuckeye.osu.edu',
    'wexnermedical.osu.edu',
    'osumc.edu',
    'osuhp.osumc.edu',
    'osuhp-test.osumc.edu',
    'webmaster.osumc.edu'
    // Add more emails extensions here
];